module.exports = __webpack_public_path__ + "img/swiper-19.8d5f13be.png";